
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import UploadImg from '@/components/upload-img.vue';
	import PageFooter from '@/components/page-footer.vue';
	
	import E from 'wangeditor';
	
	
	import {
		createActivityInfo,
		setActivityInfo,
		getActivityDetail
	} from '@/api/material'
	import {
		getOssToken
	} from '@/api/user'

	@Component({
		name: 'message-detail',
		components: {
			PageFooter,
			UploadImg
		}
	})
	export default class MessageDetail extends Vue {
		private id = +this.$route.query.id;
		private type = this.$route.query.type;
		private formData: any = {
			Title: '',
			Subtitle: '',
			ThumbImgUrl: '',
			LinkUrl: '',
			EffectiveTime: '',
			InformationType: 1,
			Content: '',
			IsEffectiveImmediately: true
		}
		private oldThumb = []

		private formRule: any = {
			'Title': '请输入资讯标题',
			'Subtitle': '请输入副标题',
			'ThumbImgUrl': '请上传封面图',
		}

		private isSendNow = 1
		private token: any = {};
		private editor:any = {};

		private mounted() {
			
			this.getToken();
			this.initEditor();
			
			if (this.id) {
				this.getDetail();
			}
		}
		
		//初始化富文本框
		private initEditor(){
			this.editor = new E('#editContent');
			this.editor.config.zIndex = 1;
			this.editor.config.onchange = (newHtml: any) => {
				this.formData.Content = newHtml
			}
			this.editor.create();
		}

		// 获取详情
		private async getDetail() {
			try {
				const res: any = await getActivityDetail({
					Id: +this.id
				})
				this.formData = res.Result;
				this.editor.txt.html(res.Result.Content);
				this.oldThumb = [res.Result.ThumbImgUrl];
			} catch (e) {
				console.log(e)
			}
		}

		// 数据是否为空
		private isEmpty() {
			for (let key in this.formData) {
				
				if (this.formRule[key] && !this.formData[key]) {
					this.$message({
						type: 'warning',
						message: this.formRule[key]
					})
					return true
				}
				
				if(this.formData.InformationType === 1 && !this.formData.LinkUrl){
					this.$message({
						type: 'warning',
						message: '请输入链接'
					})
					return true;
				}
				
				if (!this.formData.IsEffectiveImmediately && !this.formData.EffectiveTime) {
					this.$message({
						type: 'warning',
						message: '请选择发送时间'
					})
					return true;
				}
				
			}
			return false;
		}

		private async getToken() {
			try {
				const res: any = await getOssToken({})
				this.token = {
					AccessKeySecret: res.access_key_secret,
					OSSAccessKeyId: res.access_key_id,
					SecurityToken: res.security_token
				}
			} catch (e) {
				console.log('getOssToken ===>', e)
			}
		}

		private handleUpload(list: any) {
			this.formData.thumb = list[0];
		}

		private submit() {
			// if (this.isEmpty()) return;
			// if (this.formData.EffectiveTime) {
			// 	// this.formData.EffectiveTime = parseInt(this.formData.send_time / 1000 + '')
			// } else {
			// 	this.formData.EffectiveTime = 0;
			// }
			
			this.doCreate()
		}

		private async doCreate() {
			try {
				await createActivityInfo(this.formData)
				this.$message({
					type: 'success',
					message: '编辑成功！',
					onClose: () => {}
				})
				this.toBack()
			} catch (e) {
				console.log(e)
			}
		}

		// private async doUpdate() {
		// 	// this.formData.activity_id = this.id
		// 	try {
		// 		await setActivityInfo(this.formData)
		// 		this.$message({
		// 			type: 'success',
		// 			message: '更新成功！',
		// 			onClose: () => {}
		// 		})
		// 		this.toBack()
		// 	} catch (e) {
		// 		console.log(e)
		// 	}
		// }

		private toBack() {
			this.$router.go(-1)
		}
	}
